module.exports = ".actions-col{width:120px;text-align:center}.slack-auth-button{width:170px;height:40px}"